import {Component, inject, Input} from '@angular/core';
import {ButtonWithIconComponent} from "../../buttons/button-with-icon/button-with-icon.component";
import {ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-tooltip-modal',
  standalone: true,
  imports: [
    ButtonWithIconComponent,
   
    ReactiveFormsModule,
    TranslateModule
  ],
  template: `
    <div class="modal-header">
      <div class="d-flex justify-content-between align-items-center w-100">
        <h4 class="modal-title poppins-text p-2">{{title | translate}}</h4>
        <button class="pointer-style icon-button text-size-30" aria-label="Close"
                (click)="activeModal.close(false)">
          <i class="fa-solid fa-circle-xmark"></i>
        </button>
      </div>
    </div>
    <div class="modal-body" >
      <div [innerHTML]="tutorial | translate"></div>
    </div>
  `,
  styles: `
  .modal-body {text-align: justify}
  `
})
export class TooltipModalComponent {
  activeModal = inject(NgbActiveModal)
  @Input() tutorial: string;
  @Input() title: string;
}
